import * as CONFIG from './config';
import axios from 'axios';
import * as jwt from 'jsonwebtoken';

exports.login = function (objModel) {
    // console.log("login==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPostLogin('/login', objModel)
            .then(function (response) {
                // console.log('login succ==>', response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('login err==>', err);
                reject(err);
            });
    });
}

exports.refreshToken = function () {
    // console.log("refreshToken==>");
    return new Promise((resolve, reject) => {
        //{"committee_name":""}
        return CONFIG.httpPostRefreshToken('/login/refreshToken')
            .then(function (response) {
                // console.log('refreshToken succ==>', response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('refreshToken err==>', err);
                reject(err);
            });
    });
}

exports.changeRole = function (role_id) {
    // console.log("changeRole==>");
    return new Promise((resolve, reject) => {
        //{"committee_name":""}
        return CONFIG.httpPostChangeRole('/login/changeRole/'+role_id)
            .then(function (response) {
                // console.log('changeRole succ==>', response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('changeRole err==>', err);
                reject(err);
            });
    });
}

exports.changepassword = function (oldPass, newPass) {
    // console.log("changepassword==>");
    return new Promise((resolve, reject) => {
        //{"committee_name":""}
        return CONFIG.httpPost('/users/changePass/' + oldPass + '/' + newPass)
            .then(function (response) {
                // console.log('changepassword succ==>', response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('changepassword err==>', err);
                reject(err);
            });
    });
}

exports.getUserAD = function (user) {
    // console.log("getUserAD==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpGet('/users/getUserAD/' + user)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                // console.log(err);
                // console.log('err', err);
                reject(err);
            });
    });
}

exports.getUser = function (id) {
    // console.log("getUserList==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpGet('/users/UserWithRoles/' + id)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                // console.log(err);
                // console.log('err', err);
                reject(err);
            });
    });
}

exports.getPendingUser = function (id) {
    // console.log("getUserList==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpGet('/users/UserWithRolesWithOperation/' + id)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                // console.log(err);
                // console.log('err', err);
                reject(err);
            });
    });
}

exports.getUserList = function (id) {
    // console.log("getUserList==>",id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpGet('/users/userlist' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                // console.log(err);
                // console.log('err', err);
                reject(err);
            });
    });
}

exports.getUserOrderList = function (id) {
    // console.log("getUserOrderList==>",id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpGet('/users/UserListOrder' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                // console.log(err);
                // console.log('err', err);
                reject(err);
            });
    });
}

exports.getPendingApprovalList = function () {
    // console.log("getPendingApprovalList==>", id);
    return new Promise((resolve, reject) => {
        return CONFIG.httpGet('/users/pendingUserListWithChecker')
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.getRejectedRolesList = function () {
    // console.log("getRejectedRolesList==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpGet('/users/UserListRejected')
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.addUser = function (objModel) {
    // console.log("addUser==>");
    return new Promise((resolve, reject) => {
        //{"committee_name":""}
        return CONFIG.httpPost('/users', objModel)
            .then(function (response) {
                // console.log('addUser succ==>', response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('addUser err==>', err);
                reject(err);
            });
    });
}

exports.updateUser = function (objModel) {
    // console.log("updateUser==>");
    return new Promise((resolve, reject) => {
        //{"committee_name":""}
        return CONFIG.httpPut('/users', objModel)
            .then(function (response) {
                // console.log('updateUser succ==>', response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('updateUser err==>', err);
                reject(err);
            });
    });
}

exports.deleteUserRole = function (user_id, objModel) {
    // console.log("deleteUserRole==>",objModel);
    return new Promise((resolve, reject) => {
        //{"committee_name":""}
        return CONFIG.httpPost('/users/deleteRole/' + user_id, objModel)
            .then(function (response) {
                // console.log('updateUser succ==>', response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('updateUser err==>', err);
                reject(err);
            });
    });
}

exports.grant = function (user_id, device_count) {
    // console.log("addUser==>");
    return new Promise((resolve, reject) => {
        //{"committee_name":""}
        return CONFIG.httpPost('/users/grant/' + user_id + '/' + device_count)
            .then(function (response) {
                // console.log('addUser succ==>', response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('addUser err==>', err);
                reject(err);
            });
    });
}

exports.grantArchiveMeeting = function (user_id) {
    // console.log("grantArchiveMeeting==>");
    return new Promise((resolve, reject) => {
        //{"committee_name":""}
        return CONFIG.httpPost('/users/grantArMeet/' + user_id)
            .then(function (response) {
                // console.log('grantArchiveMeeting succ==>', response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('grantArchiveMeeting err==>', err);
                reject(err);
            });
    });
}

exports.revoke = function (user_id) {
    // console.log("revoke==>");
    return new Promise((resolve, reject) => {
        //{"committee_name":""}
        return CONFIG.httpPost('/users/revokeUser/' + user_id)
            .then(function (response) {
                // console.log('revoke succ==>', response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('revoke err==>', err);
                reject(err);
            });
    });
}

exports.unlock = function (user_id) {
    // console.log("addUser==>");
    return new Promise((resolve, reject) => {
        //{"committee_name":""}
        return CONFIG.httpPost('/users/unlockUser/' + user_id)
            .then(function (response) {
                // console.log('addUser succ==>', response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('addUser err==>', err);
                reject(err);
            });
    });
}

exports.lock = function (user_id) {
    // console.log("addUser==>");
    return new Promise((resolve, reject) => {
        //{"committee_name":""}
        return CONFIG.httpPost('/users/lockUser/' + user_id)
            .then(function (response) {
                // console.log('addUser succ==>', response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('addUser err==>', err);
                reject(err);
            });
    });
}



exports.resetpassword = function (user_id) {
    // console.log("resetpassword==>");
    return new Promise((resolve, reject) => {
        //{"committee_name":""}
        return CONFIG.httpPost('/users/resetpassword/' + user_id)
            .then(function (response) {
                // console.log('resetpassword succ==>', response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('resetpassword err==>', err);
                reject(err);
            });
    });
}

exports.deleteUser = function (user_id) {
    // console.log("deleteUser==>");
    return new Promise((resolve, reject) => {
        //{"committee_name":""}
        return CONFIG.httpPost('/users/deleteUser/' + user_id)
            .then(function (response) {
                // console.log('deleteUser succ==>', response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('deleteUser err==>', err);
                reject(err);
            });
    });
}

exports.deleteRejectedUser = function (user_id) {
    // console.log("deleteUser==>");
    return new Promise((resolve, reject) => {
        //{"committee_name":""}
        return CONFIG.httpPost('/users/deleteRejectedUser/' + user_id)
            .then(function (response) {
                // console.log('deleteUser succ==>', response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('deleteUser err==>', err);
                reject(err);
            });
    });
}

exports.approveUser = function (user_id) {
    // console.log("approveUser==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/users/ApproveUser/' + user_id)
            .then(function (response) {
                // console.log('approveUser succ==>', response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('approveUser err==>', err);
                reject(err);
            });
    });
}

exports.rejectUser = function (user_id) {
    // console.log("rejectUser==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/users/RejectUser/' + user_id)
            .then(function (response) {
                // console.log('rejectUser succ==>', response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('rejectUser err==>', err);
                reject(err);
            });
    });
}

exports.updateUserOrder = function (user_id, order_number, oldIndex) {
    // console.log("rejectUser==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/users/updateUserOrder/' + user_id + '/' + order_number +'/'+ oldIndex)
            .then(function (response) {
                // console.log('rejectUser succ==>', response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('rejectUser err==>', err);
                reject(err);
            });
    });
}



// WEBPACK FOOTER //
// ./api/userdetails.js